import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-star\"><path d=\"m12 2.6 2.85 5.77 6.37.93-4.61 4.49 1.09 6.35-5.7-2.48-5.7 2.97 1.09-6.35L2.78 9.3l6.37-.93z\" fill=\"currentColor\" fill-opacity=\".14\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol